<splash-screen [duration]="3" [animationDuration]="0.5"></splash-screen>
<div class="toolbar" role="banner">
  <img
    width="40"
    alt="My Premises Logo"
    src="logo_rounded.png"
  />
    <span>My Premises</span>
      <div class="spacer"></div>
      <button class="btn btn-light mx-4" (click)="openNotices()" title="Notices">
        <fa-icon [icon]="faBell"></fa-icon>
      </button>
      <button class="btn btn-light mx-4" (click)="openChangePassword()" title="Change password">
        <fa-icon [icon]="faKey"></fa-icon>
      </button>
      <button class="btn btn-light  mx-4" (click)="logout()" >
        <fa-icon  [icon]="faSignOutAlt"></fa-icon>
      </button>
  </div>

  @if (isAdmin()) {
<div  class="content" role="main">

    <!-- Highlight Card -->
    <div class="card highlight-card card-small">



      <span>Simplify your property management!</span>



    </div>


  </div>
}

  @if (isUser() && !isAdmin()) {
<div class="content" role="main">

  </div>
}
  <div class="card highlight-card card-small">
    <span>Welcome to My Premises</span>
  </div>

  @if (isUser() && !isAdmin()) {
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4 text-center my-4">
        <a routerLink="/notices"><fa-icon class="l-icon" [icon]="faBell"></fa-icon></a>
        <p routerLink="/notices">Notices</p>
      </div>
      <div class="col-12 col-md-4 text-center my-4">
        <a routerLink="/premises"><fa-icon class="l-icon" [icon]="faBuilding"></fa-icon></a>
        <p routerLink="/premises">Maintenance</p>
      </div>
      <div class="col-12 col-md-4 text-center my-4">
        <a routerLink="/breaches"><fa-icon class="l-icon" [icon]="faGavel"></fa-icon></a>
        <p routerLink="/breaches">Breaches</p>
      </div>
      <div class="col-12 col-md-4 text-center my-4">
        <a routerLink="/complaints"><fa-icon class="l-icon" [icon]="faComments"></fa-icon></a>
        <p routerLink="/complaints">Complaints</p>
      </div>
      <div class="col-12 col-md-4 text-center my-4">
        <a routerLink="/laws"><fa-icon class="l-icon" [icon]="faScaleBalanced"></fa-icon></a>
        <p routerLink="/laws">Laws</p>
      </div>
    </div>
  </div>
}

  @if (isAdmin()) {
<div  class="container">
  <div class="row">
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-notices"><fa-icon class="l-icon" [icon]="faBell"></fa-icon></a>
      <p routerLink="/manage-notices">Notices</p>
    </div>
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-property"><fa-icon class="l-icon" [icon]="faBuilding"></fa-icon></a>
      <p routerLink="/manage-property">Manage Property</p>
    </div>
    <div class="col-md-4 text-center my-4">
      <a routerLink="/compliance"><fa-icon class="l-icon" [icon]="faTachometerAlt"></fa-icon></a>
      <p routerLink="/compliance">Compliance</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-subscription"><fa-icon class="l-icon" [icon]="faFileInvoiceDollar"></fa-icon></a>
      <p routerLink="/manage-subscription">Subscription</p>
    </div>
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-breaches"><fa-icon class="l-icon" [icon]="faGavel"></fa-icon></a>
      <p routerLink="/manage-breaches">Breaches</p>
    </div>
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-complaints"><fa-icon class="l-icon" [icon]="faComments"></fa-icon></a>
      <p routerLink="/manage-complaints">Complaints</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 text-center my-4">
      <a routerLink="/manage-laws"><fa-icon class="l-icon" [icon]="faScaleBalanced"></fa-icon></a>
      <p routerLink="/manage-laws">Laws</p>
    </div>
  </div>
</div>
}
    <!-- Resources -->
    <!-- <h2>Are you a Property owner?</h2>
    <p>Check your outstanding maintenance now</p>

    <div class="card-container">

      <a class="card" rel="noopener" href="/query-maintenance">

        <span><fa-icon class="l-icon fa-2x" [icon]="faSearch"></fa-icon> Query Maintenance</span>

      </a>

    </div> -->
